import articleMapping from "../common/article-mapping.json" assert { type: "json" };
// Type the imported JSON to match the ArticleData structure
const typedArticleMapping = articleMapping;
export default typedArticleMapping;
